import { render, staticRenderFns } from "./delete-parcel-modal.vue?vue&type=template&id=60098acd"
import script from "./delete-parcel-modal.vue?vue&type=script&lang=ts"
export * from "./delete-parcel-modal.vue?vue&type=script&lang=ts"
import style0 from "./delete-parcel-modal.vue?vue&type=style&index=0&id=60098acd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports